export const DEFAULT_BLOCKCHAIN_DELAY = 1000 // polling every second
export const DEFAULT_API_DELAY = 5000 // polling every 5 second
export const TX_HASH_KEY = 'txHash'
export const IRIS_ATTESTATION_API_URL = 'https://iris-api.circle.com' // 'https://iris-api-sandbox.circle.com'

export const LCD_URL_JOLTIFY = 'https://lcd.joltify.io'
export const RPC_URL_JOLTIFY = 'https://rpc.joltify.io'